module.exports = __webpack_public_path__ + "static/media/times.b018e0f6.svg";